import { Card, Table } from '@insight-health-ai/roseate/components';
import { useGetAppointments } from 'src/hooks/frontdesk';
import { getColumns } from './constants';

export const AppointmentsList = () => {
  const { data, isLoading, error } = useGetAppointments();

  if (error) {
    return (
      <div className="flex justify-center items-center p-8">
        <div className="text-red-500 text-lg">Error loading appointments</div>
      </div>
    );
  }

  const appointments = data?.appointmentList || [];

  return (
    <div
      style={{ height: 'calc(100dvh - 100px)' }}
      className="page-wrapper care-connect-page"
    >
      <Card title="Appointments" padding={{ body: 'none' }}>
        <Table
          columns={getColumns()}
          data={appointments}
          loading={isLoading}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} appointments`,
          }}
          emptyText="No appointments found"
        />
      </Card>
    </div>
  );
};
